$(function () {
    const COOKIE_NAME    = 'ALLOW_COOKIES';
    const COOKIE_VERSION = '1.0';
    const COOKIE_DAYS    = 365;

    const $modal                = $('#cookie-compliant');
    const $abrirPoliticaCookies = $('#abrirPoliticaCookies');
    const $aceptarCookies       = $('#aceptarCookies');
    const $rechazarCookies      = $('#rechazarCookies');
    const $configurarCookies    = $('#configurarCookies');
    const $guardarCookies       = $('#guardarCookies');
    const $aceptarTodasCookies  = $('#aceptarTodasCookies');
    const $configTabButton      = $('#cookies-config-tab');
    const $policyTabButton      = $('#cookies-policy-tab');
    const $openConfigButtons    = $('[data-open-cookie-config], #config-cookies');

    const $analyticsMasterToggle  = $('#cookiesAnaliticasTodas');
    const $analyticsToggles       = $('[data-cookie-consent="analytics"]');
    const $clarityToggles         = $('[data-cookie-consent="clarity"]');
    const $analyticsCookieToggles = $analyticsToggles.add($clarityToggles);

    const $cookiesAnalytics = $('#cookiesAnalyticsGa');
    const $cookiesClarity   = $('#cookiesClarityClck');

    let cookieModal = null;

    if ($modal.length && window.bootstrap) {
        cookieModal = new bootstrap.Modal($modal[0], {
            backdrop: 'static',
            keyboard: false
        });
    }

    /**
     * Crea o actualiza una cookie del navegador.
     *
     * @param    name
     * @param    value
     * @param    days
     */
    function setCookie(name, value, days) {
        const date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        document.cookie =
            name + '=' + encodeURIComponent(value) +
            '; expires=' + date.toUTCString() +
            '; path=/' +
            '; SameSite=Lax';
    }

    /**
     * Obtiene una cookie del navegador por nombre.
     *
     * @param      name
     * @returns    {null|string}
     */
    function getCookie(name) {
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            const cookie = $.trim(cookies[i]);

            if (cookie.indexOf(name + '=') === 0) {
                return decodeURIComponent(cookie.substring(name.length + 1));
            }
        }

        return null;
    }

    /**
     * Muestra el modal de cookies.
     */
    function showModal() {
        if (cookieModal) {
            cookieModal.show();
        }
    }

    /**
     * Oculta el modal de cookies.
     */
    function hideModal() {
        if (cookieModal) {
            cookieModal.hide();
        }
    }

    /**
     * Lee y valida el consentimiento guardado.
     * Si no existe, está corrupto o pertenece a otra versión, devuelve null.
     *
     * @param      rawConsent
     * @returns    {any|null}
     */
    function parseConsent(rawConsent) {
        if (!rawConsent) {
            return null;
        }

        try {
            const consent = JSON.parse(rawConsent);

            if (
                consent.version !== COOKIE_VERSION ||
                typeof consent.analytics !== 'boolean' ||
                typeof consent.clarity !== 'boolean'
            ) {
                return null;
            }

            return consent;
        } catch (error) {
            return null;
        }
    }

    /**
     * Construye el objeto de consentimiento que se guardará en ALLOW_COOKIES.
     *
     * @param      analytics
     * @param      clarity
     * @returns    {{ analytics: boolean, clarity: boolean, timestamp: string, version: string }}
     */
    function buildConsent(analytics, clarity) {
        return {
            analytics: !!analytics,
            clarity:   !!clarity,
            timestamp: new Date().toISOString().split('T')[0],
            version:   COOKIE_VERSION
        };
    }

    /**
     * Copia un script encontrado dentro de un bloque noscript.
     * Es necesario recrearlo para que el navegador lo ejecute.
     *
     * @param      source
     * @returns    {HTMLScriptElement}
     */
    function copyScript(source) {
        const script = document.createElement('script');

        $.each(source.attributes, function () {
            script.setAttribute(this.name, this.value);
        });

        script.text = source.textContent;

        return script;
    }

    /**
     * Convierte el contenido HTML de un noscript en nodos ejecutables.
     * Si encuentra scripts, los recrea para que se ejecuten correctamente.
     *
     * @param      content
     * @returns    {DocumentFragment}
     */
    function buildExecutableFragment(content) {
        const template = document.createElement('template');
        const fragment = document.createDocumentFragment();

        template.innerHTML = $.trim(content);

        $(template.content.childNodes).each(function () {
            if (this.nodeType === Node.ELEMENT_NODE && this.tagName.toLowerCase() === 'script') {
                fragment.appendChild(copyScript(this));
                return;
            }

            fragment.appendChild(this.cloneNode(true));
        });

        return fragment;
    }


    /**
     * Carga los bloques de cookies permitidos.
     * cookie-block-b = Google Analytics
     * cookie-block-c = Microsoft Clarity
     *
     * @param    className
     */
    function loadCookieBlocks(className) {
        $('noscript.' + className).each(function () {
            $(this).replaceWith(buildExecutableFragment(this.textContent));
        });
    }

    /**
     * Marca o desmarca un conjunto de switches.
     *
     * @param    $toggles
     * @param    checked
     */
    function setToggles($toggles, checked) {
        $toggles.prop('checked', checked);
    }

    /**
     * Devuelve true si al menos un switch del grupo está marcado.
     *
     * @param      $toggles
     * @returns    {boolean}
     */
    function isAccepted($toggles) {
        return $toggles.filter(':checked').length > 0;
    }

    /**
     * Sincroniza el formulario con el consentimiento guardado.
     *
     * @param    consent
     */
    function syncForm(consent) {
        setToggles($analyticsToggles, consent.analytics);
        setToggles($clarityToggles, consent.clarity);
        updateAnalyticsMasterToggle();
    }

    /**
     * Aplica el consentimiento cargando los scripts autorizados.
     *
     * @param    consent
     */
    function applyConsent(consent) {
        if (consent.analytics) {
            loadCookieBlocks('cookie-block-b');
        }

        if (consent.clarity) {
            loadCookieBlocks('cookie-block-c');
        }
    }

    /**
     * Guarda el consentimiento del usuario.
     * Si el usuario revoca cookies que ya estaban aceptadas, recarga la página para evitar que sigan activos scripts ya inicializados.
     *
     * @param    analytics
     * @param    clarity
     */
    function saveConsent(analytics, clarity) {
        const previousConsent = parseConsent(getCookie(COOKIE_NAME));
        const consent         = buildConsent(analytics, clarity);

        const hasRevokedAnalytics = previousConsent && previousConsent.analytics && !consent.analytics;
        const hasRevokedClarity   = previousConsent && previousConsent.clarity && !consent.clarity;
        const shouldReload        = hasRevokedAnalytics || hasRevokedClarity;

        setCookie(COOKIE_NAME, JSON.stringify(consent), COOKIE_DAYS);
        syncForm(consent);

        if (shouldReload) {
            window.location.reload();
            return;
        }

        applyConsent(consent);
        hideModal();
    }

    /**
     * Muestra la pestaña de configuración del modal.
     */
    function showConfigTab() {
        if (!$configTabButton.length) {
            return;
        }

        if (window.bootstrap && window.bootstrap.Tab) {
            const tab = new bootstrap.Tab($configTabButton[0]);
            tab.show();
            return;
        }

        $configTabButton.trigger('click');
    }

    /**
     * Abre el modal directamente en la pestaña de configuración.
     */
    function showConfigModal() {
        showModal();
        showConfigTab();
    }

    /**
     * Sincroniza los switches de un mismo proveedor.
     * Si se marca/desmarca una cookie de Google Analytics, se sincronizan todas las de Google Analytics. Lo mismo para Microsoft Clarity.
     *
     * @param    $changedToggle
     */
    function syncGroupedToggles($changedToggle) {
        const consentGroup = $changedToggle.data('cookie-consent');

        if (!consentGroup) {
            return;
        }

        setToggles(
            $('[data-cookie-consent="' + consentGroup + '"]'),
            $changedToggle.prop('checked')
        );
    }

    /**
     * Actualiza el switch general de cookies analíticas.
     * Solo queda marcado si todas las cookies analíticas están marcadas.
     */
    function updateAnalyticsMasterToggle() {
        if (!$analyticsMasterToggle.length || !$analyticsCookieToggles.length) {
            return;
        }

        const allChecked = $analyticsCookieToggles.length === $analyticsCookieToggles.filter(':checked').length;

        $analyticsMasterToggle.prop('checked', allChecked);
    }

    /**
     * Switch general: Marca o desmarca todas las cookies analíticas.
     */
    $analyticsMasterToggle.on('change', function () {
        setToggles($analyticsCookieToggles, $(this).prop('checked'));
    });

    /**
     * Switches individuales:
     * sincronizan su proveedor y actualizan el switch general.
     */
    $analyticsCookieToggles.on('change', function () {
        syncGroupedToggles($(this));
        updateAnalyticsMasterToggle();
    });

    /**
     * Estado inicial:
     * si ya existe consentimiento válido, se aplica y no se muestra el modal.
     * si no existe consentimiento válido, se muestra el modal.
     *
     * @type    {*|null}
     */
    const consent = parseConsent(getCookie(COOKIE_NAME));

    if (consent) {
        syncForm(consent);
        applyConsent(consent);
        hideModal();
    } else {
        showModal();
    }

    /**
     * Aceptar cookies: Acepta Google Analytics y Microsoft Clarity.
     */
    $aceptarCookies.on('click', function () {
        saveConsent($cookiesAnalytics.length > 0, $cookiesClarity.length > 0);
    });

    /**
     * Rechazar cookies: Rechaza Google Analytics y Microsoft Clarity.
     */
    $rechazarCookies.on('click', function () {
        saveConsent(false, false);
    });

    /**
     * Configurar cookies: Cambia a la pestaña de configuración.
     */
    $configurarCookies.on('click', function () {
        showConfigTab();
    });

    /**
     * Abre la página estática de Política de Cookie
     */
    $abrirPoliticaCookies.on('click', function (event) {
        event.preventDefault();
        $policyTabButton.trigger('click');
    })

    /**
     * Enlaces externos de configuración: Abren el modal directamente en la pestaña de configuración.
     */
    $openConfigButtons.on('click', function (event) {
        event.preventDefault();
        showConfigModal();
    });

    /**
     * Guardar configuración: Guarda el estado actual de Google Analytics y Microsoft Clarity.
     */
    $guardarCookies.on('click', function () {
        saveConsent(isAccepted($analyticsToggles), isAccepted($clarityToggles));
    });

    /**
     * Aceptar todas: Marca todos los switches y guarda el consentimiento completo.
     */
    $aceptarTodasCookies.on('click', function () {
        setToggles($analyticsCookieToggles, true);
        updateAnalyticsMasterToggle();
        saveConsent($cookiesAnalytics.length > 0, $cookiesClarity.length > 0);
    });
});
